import { requestSearch } from "../api/searchRequest";
const searchApi = requestSearch();

const getMetaResults = async ({
  uuid,
  word,
  filters,
  anchors,
  page,
  sortKey,
}) => {
  const encodedWord = encodeURIComponent(word);
  const pageQuery = `page=${page ?? 1}`;
  const sortQuery = `&sortKey=${sortKey}`;
  const anchorsQuery = anchors
    ?.map((anchor) => `&anchors[]=${anchor}`)
    .join("");
  const filtersQuery = filters
    ?.map(({ name, values }) => {
      if (name === "price") {
        return `&filters[price][min]=${values[0]}&filters[price][max]=${values[1]}`;
      } else if (Array.isArray(values)) {
        const v = [];
        values.forEach((value) => v.push(`&filters[${name}][]=${value}`));
        return v.join("");
      } else {
        return `&filters[${name}][]=${values}`;
      }
    })
    .join("");

  return await searchApi.get(
    `/${uuid}/search/${encodedWord}?${pageQuery}${sortQuery}${filtersQuery}${anchorsQuery}`
  );
};

const getAutocompleteSuggestions = async ({ input, tenant_id }) =>
  await searchApi.get(`/${tenant_id}/suggest/${input}`);

export default { getMetaResults, getAutocompleteSuggestions };
